// extracted by mini-css-extract-plugin
module.exports = {"LogsPage":"Logs_LogsPage__1L88e","LogsList":"Logs_LogsList__1vVDL","stderr":"Logs_stderr__3VESl"};